import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';

import { registrarConsentimento } from '../../services/periodoService';

/**
 * O consentimento de envio para IA, nomeando o que sai, para onde vai e o que
 * continua funcionando sem ele.
 *
 * A rota existe desde a onda 2 e não tinha tela nenhuma — mesma classe do
 * `FecharMes`, que passou uma onda inteira inalcançável: código entregue e
 * testado não é código ligado.
 *
 * Por que o texto é específico: o comprador é um consultor manuseando dado
 * financeiro de cliente dele, e vai ser perguntado por esse cliente. "Aceito os
 * termos" não é consentimento informado, e o backend grava a versão do texto
 * que foi mostrada justamente para poder provar o que foi consentido.
 */
export const VERSAO_DO_TEXTO = 'v1';

const ConsentimentoIA = ({ aberto, aoFechar, aoConcluir }) => {
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);

  const autorizar = async () => {
    setEnviando(true);
    setErro(null);
    try {
      await registrarConsentimento(true);
      if (aoConcluir) aoConcluir();
      if (aoFechar) aoFechar();
    } catch (e) {
      setErro(e.message || 'Não foi possível registrar o consentimento.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={Boolean(aberto)} onClose={aoFechar} maxWidth="sm" fullWidth>
      <DialogTitle>Autorizar a análise por IA</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <div>
            <Typography variant="subtitle2">O que sai daqui</Typography>
            <Typography variant="body2" color="text.secondary">
              Os indicadores já calculados e os sinais do período — números e frases curtas. O
              arquivo que você subiu não é enviado.
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2">Para onde vai</Typography>
            <Typography variant="body2" color="text.secondary">
              Para o provedor de IA configurado nesta instalação, com processamento fora do Brasil.
              O envio acontece no momento em que você pede o parecer, e não em segundo plano.
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2">Por quanto tempo</Typography>
            <Typography variant="body2" color="text.secondary">
              O parecer gerado fica guardado na sua conta. A retenção do lado do provedor segue a
              política dele e não é controlada por nós.
            </Typography>
          </div>
          <div>
            <Typography variant="subtitle2">O que continua funcionando sem isto</Typography>
            <Typography variant="body2" color="text.secondary">
              Tudo o que você já vê: Índice de Saúde, os sinais, o ciclo em reais, o plano de ação.
              Nada disso envia dado para fora — é calculado aqui.
            </Typography>
          </div>
          <Typography variant="caption" color="text.secondary">
            Você pode revogar esta autorização depois. Texto do consentimento: {VERSAO_DO_TEXTO}.
          </Typography>
          {erro && (
            <Typography variant="body2" color="error.main">
              {erro}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={aoFechar} disabled={enviando}>
          Agora não
        </Button>
        <Button variant="contained" onClick={autorizar} disabled={enviando}>
          {enviando ? 'Registrando…' : 'Autorizar o envio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentimentoIA;
